// MT Auto Order

export const checkMtAutoFlag = (flag) => flag === '1';

export const getMtAutoOrderTypes = (flag, orderTypes) => {
  const newOrderTypes = [...orderTypes, 'AUTO'];
  return flag ? newOrderTypes : orderTypes;
};
